import { useEffect, useRef } from "react";
import gsap from "gsap";

const CursorFollower = () => {
  const cursorRef = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    const isFinePointer = window.matchMedia("(pointer: fine)").matches;
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (!cursor || !isFinePointer || prefersReducedMotion) {
      return undefined;
    }

    gsap.set(cursor, { xPercent: -50, yPercent: -50 });

    const moveX = gsap.quickTo(cursor, "x", {
      duration: 0.35,
      ease: "power3.out",
    });
    const moveY = gsap.quickTo(cursor, "y", {
      duration: 0.35,
      ease: "power3.out",
    });

    const showCursor = () => {
      gsap.to(cursor, { autoAlpha: 1, duration: 0.2, ease: "power2.out" });
    };

    const hideCursor = () => {
      gsap.to(cursor, { autoAlpha: 0, duration: 0.2, ease: "power2.out" });
    };

    const handlePointerMove = (event) => {
      moveX(event.clientX);
      moveY(event.clientY);
      showCursor();
    };

    window.addEventListener("pointermove", handlePointerMove);
    window.addEventListener("blur", hideCursor);
    document.addEventListener("mouseleave", hideCursor);

    return () => {
      window.removeEventListener("pointermove", handlePointerMove);
      window.removeEventListener("blur", hideCursor);
      document.removeEventListener("mouseleave", hideCursor);
      moveX.tween.kill();
      moveY.tween.kill();
      gsap.killTweensOf(cursor);
    };
  }, []);

  return <span ref={cursorRef} className="cursor-follower" aria-hidden="true" />;
};

export default CursorFollower;
